@if (isPremium) {
  <div class="alerts-header">
    <h4 id="alertsHeader">Alerts</h4>
  </div>
}
<div class="modus-content-columns">
  @if (!isPremium) {
    <div class="modus-content p-4 non-premium-message">
      <h1 id="alertsHeaderNonPremium">Alerts</h1>
      <p></p>
      <p id="alertsDescriptionNonPremium">
        This feature enables users to receive reports outside the tool and share these reports with other users
      </p>
      <p></p>
      <p id="alertsTextMarketingEmail">
        Click <a target="_blank" (click)="sendMarketingEmail()" id="alertsLinkMarketingEmail"> here </a> to be contacted
        by an account representative to gain access to the full power of Construction Analytics.
      </p>
    </div>
  }
  @if (isPremium) {
    <div class="modus-panel panel-lg shadow-lg">
      <div class="add-button-header">
        <button id="alertsButtonAddNew" class="btn btn-primary" (click)="initiateCreationProcess()">Add New</button>
      </div>
      <div class="panel-body" id="alertsList">
        @if (hasItems) {
          <div class="scroll-container p-2">
            <ul id="list-group" class="list-group" [ngClass]="{ 'no-selected': !selectedItem }">
              @for (item of items | async | sortAlerts: items; track item; let i = $index) {
                <li
                  class="list-group-item"
                  [id]="'alertsListItem' + i"
                  (click)="openNotification(item)"
                  [ngClass]="{ selected: item === selectedItem }"
                >
                  <em class="modus-icon material-icons">notifications</em>
                  <div class="body-text-wrapper">
                    <div class="body-text" [id]="'alertsListName' + i">{{ item.name }}</div>
                  </div>
                </li>
              }
            </ul>
          </div>
        }
        @if (!hasItems) {
          <div class="empty-container">You are all caught up!</div>
        }
      </div>
    </div>
  }
  @if (isPremium) {
    <div role="content-container" id="content-container">
      @if (!isCreating && !selectedItem) {
        <div class="modus-content p-4" id="default-content alertsDefaultContent">
          <h1 id="alertsDefaultHeader">Alerts Setup</h1>
          <p id="alertsDefaultText">
            Create and manage alerts to receive an email notification for alerts-related activity.
          </p>
          <hr />
        </div>
      }
      @if (!isCreating && selectedItem) {
        <app-alerts-report
          [alert]="selectedItem"
          [regionFilters]="regions"
          [class.invisible]="!showSelectedItem"
          (deleteEvent)="deleteAlert()"
          (editEvent)="editAlert()"
          (closeEvent)="closeAlert()"
        ></app-alerts-report>
      }
      @if (isCreating) {
        <div class="alert-setup-container">
          <app-alert-setup [alert]="selectedItem" (returnEvent)="disableEditorComponent($event)"></app-alert-setup>
        </div>
      }
    </div>
  }
</div>
